// extracted by mini-css-extract-plugin
export var galleryImageItem = "gallery-module--galleryImageItem--eacd4";
export var galleryImages = "gallery-module--galleryImages--eb7af";